export default __webpack_public_path__ + "static/media/messages.f7ecb21d.svg";